import {Injectable} from '@angular/core';
import {MenuItemType} from '@models/sidebar/menu-item-type';
import {MenuItemIcon} from '@models/sidebar/menu-item-icon';
import {
  BUCKET_BROWSER_PAGE,
  EXTERNAL_PAGE,
  FORM_PAGE,
  FRAME_PAGE,
  INTERACTIVE_DATA_ANALYSIS,
  STATUS_EVENT_PAGE,
  TABLEAU_PAGE,
  TEMPLATE_STATUS_EVENT_PAGE,
  TEMPLATE_USER_DEFINED_PAGE,
  USER_DEFINED_PAGE,
  WEB_GL_PAGE
} from '@constants/sidebar/page-type-option-object';

@Injectable({
  providedIn: 'root'
})
export class DesignService {

  public static readonly THIS_IS_A_NODE_CLASS = 'this-is-a-node';
  public static readonly SECOND_LEVEL_CONTAINER = 'second-level-container';

  getIcon(menuItemType: MenuItemType): MenuItemIcon {
    switch (menuItemType) {
      case MenuItemType.MACHINE:
        return MenuItemIcon.MACHINE;
      case MenuItemType.MACHINE_GROUP:
        return MenuItemIcon.MACHINE_GROUP;
      case MenuItemType.NODE:
        return MenuItemIcon.NODE;
      case MenuItemType.USER_DEFINED_PAGE:
        return USER_DEFINED_PAGE.icon;
      case MenuItemType.USER_SHARED_PAGE:
        return MenuItemIcon.USER_SHARED_PAGE;
      case MenuItemType.DATA_VISUALIZATION_PAGE:
        return INTERACTIVE_DATA_ANALYSIS.icon;
      case MenuItemType.EXTERNAL_URL:
        return EXTERNAL_PAGE.icon;
      case MenuItemType.FORM_PAGE:
        return FORM_PAGE.icon;
      case MenuItemType.TABLEAU_PAGE:
        return TABLEAU_PAGE.icon;
      case MenuItemType.FRAME_PAGE:
        return FRAME_PAGE.icon;
      case MenuItemType.WEBGL_PAGE:
        return WEB_GL_PAGE.icon;
      case MenuItemType.BUCKET_BROWSER_PAGE:
        return BUCKET_BROWSER_PAGE.icon;
      case MenuItemType.STATUS_EVENT_PAGE:
      case MenuItemType.MACHINE_GROUP_STATUS_PAGE:
        return STATUS_EVENT_PAGE.icon;
      case MenuItemType.TEMPLATE_STATUS_EVENT_PAGE:
        return TEMPLATE_STATUS_EVENT_PAGE.icon;
      case MenuItemType.TEMPLATE_USER_DEFINED_PAGE:
        return TEMPLATE_USER_DEFINED_PAGE.icon;
      default :
        return MenuItemIcon.NONE;
    }
  }

  getNodeClass(type: MenuItemType): string {
    if (type === MenuItemType.NODE) {
      return DesignService.THIS_IS_A_NODE_CLASS;
    }
    return '';
  }

}
